// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/chat/v1/portal_service.proto (package spwn.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { PortalChatServiceSaveStreamingAnnouncementRequest, PortalChatServiceSaveStreamingAnnouncementResponse } from "./portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.chat.v1.PortalChatService
 */
export const PortalChatService = {
    typeName: "spwn.chat.v1.PortalChatService",
    methods: {
        /**
         * @generated from rpc spwn.chat.v1.PortalChatService.SaveStreamingAnnouncement
         */
        saveStreamingAnnouncement: {
            name: "SaveStreamingAnnouncement",
            I: PortalChatServiceSaveStreamingAnnouncementRequest,
            O: PortalChatServiceSaveStreamingAnnouncementResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map